module.exports = __webpack_public_path__ + "img/ascenti-logo.2086e3e4.png";